export default __webpack_public_path__ + "static/media/faqicon6.054421ad.svg";